import { memo } from 'react';

import { StaticRectangle } from '../../../../components/rectangle';
import { MultiStoreCalendar } from './multi-store-calendar';
import { MultiStoreSummary } from './multi-store-summary';

// Prende il posto del DatePicker quando c'è almeno un centro aggiunto: riga di riepilogo dei
// centri (col pannello sotto) e calendario unificato. Nessun hook qui: StaticRectangle
// rimonta i figli a ogni render (key nanoid), quindi lo stato vive nel calendario, come nel
// DatePicker classico.
export const MultiStoreDatePicker = memo(
  function MultiStoreDatePicker(): JSX.Element {
    return (
      <div className="multi-store-section">
        <MultiStoreSummary />
        <StaticRectangle>
          <MultiStoreCalendar />
        </StaticRectangle>
      </div>
    );
  }
);
